import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import request from '@/utils/request'

// element ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

import '@/permission'
import '@/css/sideBar.scss'

// 第三方插件
import Cookies from 'js-cookie'
import '@/css/font-awesome-4.7.0/css/font-awesome.min.css'

// 语言文件
import zhLang from '@/lang/zh'
import enLang from '@/lang/en'

import * as filters from '@/utils/filter'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.use(ElementUI, { locale: ((localStorage.getItem('cloud_lang') == 'en') ? enLocale : zhLocale) })

Vue.prototype.store = store
Vue.prototype.request = request
Vue.prototype.Cookies = Cookies

Vue.config.productionTip = false
window.Promise = Promise

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data: {
    version: 'V1.1',
    langType: 'zh', // 语言包，默认中文
    lang: zhLang, // 语言包，默认中文
    defaultActive: '',
    fileUpload: process.env.BASE_API + '/manager/app/upload',
    amsUpload: process.env.BASE_API + '/manager/ams/upload'
  },
  created() { 
  	this.checkLang()
  },
  methods: {
  	// 检查语言类型，初始化语言包
  	checkLang() {
      this.langType = ((this.getStorage('cloud_lang') ? this.getStorage('cloud_lang') : this.langType))
  		if(this.langType == 'en') {
  			this.lang = enLang
  		} else {
  			this.lang = zhLang
  		}
  	},
    // 扫码枪监听
    initListen(params) {
      var base = this
      var scanValue = ''
      // var scanRole = /^IMEI:.*$/
      // var scanRole = /^IMEI:[a-zA-Z0-9]*,SN:[a-zA-Z0-9]*.*$/
      var scanRole = params.role
      document.onkeypress = function(event){
          var keyCode = event.code
          var keyValue = event.key
          if(keyCode == 'Enter') {
            if(scanRole.test(scanValue)) {
              params.value = scanValue
              base.sacnSuccess(params)
              scanValue = ''
            } else {
              scanValue = ''
            }
          } else {
            scanValue+= keyValue + ''
          }
      }
    },
    sacnSuccess(params) {
      if(params.callback) {
        params.callback(params)
      } else {
        alert(params.value)
      }
    },
    optionProcess(option) {
      for(var i in option) {
        var item = option[i]
        if(!item && item!==0 && item!==false) {
          delete option[i]
        }
      }
      return option
    },
    matchValue(base, data, key) {
      try {
        return base[data][((key) ? key : 'title')]
      } catch(e) {
        return false
      }
    },
  	setStorage(key,value) {
  		localStorage.setItem(key,value)
  	},
  	getStorage(key) {
  		return localStorage.getItem(key)
  	},
  	removeStorage(key) {
  		localStorage.removeItem(key)
  	}
  }
})



// WEBPACK FOOTER //
// ./src/main.js